import { render, staticRenderFns } from "./m_indonesian_native_teacher_classB.vue?vue&type=template&id=3e306564&scoped=true"
import script from "./m_indonesian_native_teacher_classB.vue?vue&type=script&lang=js"
export * from "./m_indonesian_native_teacher_classB.vue?vue&type=script&lang=js"
import style0 from "./m_indonesian_native_teacher_classB.vue?vue&type=style&index=0&id=3e306564&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e306564",
  null
  
)

export default component.exports